import CheckoutPage from "../Checkout";
import Home from "../Home";
import { Route, Switch } from "react-router-dom";
import SuccessCompra from "../Checkout/SuccessCompra";
import ConcluirContato from "../../Components/Shell/FormContato/ConcluirContato";

export const MainSwitch = () => {
  return (
    <Switch>
      <Route
        exact
        key="ConcluirContato"
        path="/concluir_contato"
        component={ConcluirContato}
      />
      <Route
        key="Plan"
        exact
        path="/venda/:identifier/concluir"
        component={SuccessCompra}
      />
      <Route
        key="Plan"
        exact
        path="/venda/:identifier"
        component={CheckoutPage}
      />
      <Route key="Home" path="*" component={Home} />
    </Switch>
  );
};
